module.exports = __webpack_public_path__ + "static/media/ST 15.cdec11be.jpg";